export default function GenerateDefinitions (arrayOfSteps) {
  const step = arrayOfSteps.map(steps => steps.step).filter(elemt => elemt.type !== 'qrSignStep' && elemt.type !== 'transactSignStep');

  const definitions = {
    signatures: {
      type: 'object',
      required: ['type'],
      properties: {
        type: {
          title: 'processDetail:signature',
          type: 'string',
          enum: step.map(elemt => elemt.type),
          enumNames: step.map(elemt => 'processDetail:stepType:' + elemt.type)
        }
      },
      dependencies: {
        type: {
          oneOf: [
            {
              properties: {
                type: {
                  enum: ['biometricOnBoardingStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['otpSignStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['blockchainIdentitySignStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['stampSignStep']
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['timeStampStep']
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['padSignStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['biometricSignStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['aproveStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['attendedSignStep']
                },
                email: {
                  title: 'Email',
                  type: 'string',
                  format: 'email',
                  pattern: '^\\S+@\\S+\\.\\S+$'
                }
              }
            }
          ]
        }
      }
    }
  };

  return definitions;
}
